var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"debugContainer",staticClass:"\n\t\tw-100\n\t\th-100\n\t\toverflow-hidden\n\t\tposition-absolute\n\t\tpointer-events-none\n\t",attrs:{"id":"debugContainer"}})}
var staticRenderFns = []

export { render, staticRenderFns }